import { useQuery } from '@tanstack/react-query';
import { EleveGroup } from '@teetsh/app/src/types/eleveGroups';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

export const EPHEMERAL_GROUPS_KEY = 'ephemeralEleveGroups';

interface Props {
  from: string; // YYYY-MM-DD format
  to: string; // YYYY-MM-DD format
  enabled?: boolean;
}

export function useEphemeralEleveGroups({ from, to, enabled = true }: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();

  return useQuery<EleveGroup[]>({
    queryKey: [schoolyear.id, school.id, EPHEMERAL_GROUPS_KEY, from, to],
    queryFn: () =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleve-groups/ephemeral?from=${from}&to=${to}`,
        {
          method: 'GET',
        },
      ).then(({ data }) => data || []),
    enabled: enabled && !!from && !!to,
  });
}
